import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}